import React from 'react';
import { Button, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { FileInfo } from '../types';

interface FileDownloadButtonProps {
	fileInfo: FileInfo;
	onFetchUrl: () => Promise<void>;
	defaultLabel?: string;
}

/**
 * Reusable component for rendering file download buttons
 * Handles loading, error, and success states
 */
export const FileDownloadButton: React.FC<FileDownloadButtonProps> = ({
	fileInfo,
	onFetchUrl,
	defaultLabel = 'File',
}) => {
	if (fileInfo.loading) {
		return (
			<Typography.Text type="secondary" style={{ fontSize: '12px' }}>
				Loading URL...
			</Typography.Text>
		);
	}

	if (fileInfo.error) {
		return (
			<Typography.Text type="danger" style={{ fontSize: '12px' }}>
				{fileInfo.error}
			</Typography.Text>
		);
	}

	if (fileInfo.url) {
		return (
			<Button
				type="link"
				icon={<DownloadOutlined />}
				onClick={() => {
					if (fileInfo.url) {
						window.open(fileInfo.url, '_blank');
					}
				}}
				style={{ padding: 0, height: 'auto' }}
			>
				<Typography.Text style={{ fontSize: '12px' }}>
					{fileInfo.name || `Download ${defaultLabel}`}
				</Typography.Text>
			</Button>
		);
	}

	return (
		<Button
			type="link"
			icon={<DownloadOutlined />}
			onClick={async () => {
				try {
					await onFetchUrl();
				} catch (error) {
					// Error is already set in state
				}
			}}
			style={{ padding: 0, height: 'auto' }}
		>
			<Typography.Text style={{ fontSize: '12px' }}>
				{fileInfo.name || defaultLabel}
			</Typography.Text>
		</Button>
	);
};
